import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TDeleteBudgetFile = {
    attachmentId: string;
    projectId: string;
};

export default async ({ attachmentId, projectId }: TDeleteBudgetFile) => {
    const tempHeaders = {
        auth: true,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/project/${projectId}/attachment/${attachmentId}`,
        method: "delete",
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
